import Chart from 'react-apexcharts';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import DashboardRequestService from 'services/dashboard-request';

export default function TotalAccumulatedRevenueRender({fiscalYear}) {

  const data_default = useMemo(()=>{
    let data = fiscalYear.programs.map((p)=>{
      return {
        name: p.name,
        values: []
      }
    })

    return [...data,{
      name: "Outros",
      values: []
    }]
  },[fiscalYear]);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const ref = useRef(null);
  
  const getProps = useCallback(() => {
    if(ref && ref.current){
      const current = ref.current;
      return {
        width: current.getBoundingClientRect().width - 30
      }
    }
    const minWidth = 440;
    const isMobile = window.innerWidth <= minWidth;

    let retorno = {};
    if (!isMobile) {
      retorno.width = 340;
    }

    return retorno;
  },[ref])

  const showNotData = useMemo(()=>{
    return data.reduce((total, type) => {
      if(type.values.length == 0) return total;

      let v = type.values.reduce((total2, value)=>{
        return total2 + value.value;
      }, 0);
      return total + v;
    }, 0) == 0;
  },[data]);

  useEffect(()=>{
    let filters = {
      sort_by: 'month',
      fiscal_year_id: fiscalYear.id,
    };

    setLoading(true);
    DashboardRequestService
      .getDataByMonth(filters)
      .then(({data}) => {
        // console.log("Faturamento total acumulado",data);
        setData(data)
        // set(data.data);
      }).finally(()=>{
        setLoading(false)
      });
  },[fiscalYear]);

  return (
    <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100" ref={ref}>
      <Row>
        <Col md="12">
          <span className="dashboard-card-h5 text-left">
            Faturamento total acumulado
          </span>
        </Col>
        <Col md="12">
          <hr></hr>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs="auto" md="auto">
          <Chart
            options={{
              labels: (loading?data_default:data).map(a=>a.name),
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200,
                    },
                    legend: {
                      position: 'bottom',
                    },
                  },
                },
              ],
              tooltip: {
                y: {
                  formatter: function (d) {
                    return d
                      ? 'R$ ' +
                      d.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                      })
                      : '';
                  },
                },
              },
              animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                  enabled: true,
                  delay: 150,
                },
                dynamicAnimation: {
                  enabled: true,
                  speed: 350,
                },
              },
            }}
            series={
              (loading?data_default:data).map((d)=>{
                return d.values.reduce((total, value) => {
                  return total + value.value;
                }, 0)
              })
              // fiscalYear == 12 ? [
              //   graphElitePass.reduce((total, value) => {
              //     return total + value.value;
              //   }, 0),
              //   graphElite.reduce((total, value) => {
              //     return total + value.value;
              //   }, 0),
              //   graphEliteManager.reduce((total, value) => {
              //     return total + value.value;
              //   }, 0),
              //   graphScancash.reduce((total, value) => {
              //     return total + value.value;
              //   }, 0),
              //   graphOthers.reduce((total, value) => {
              //     return total + value.value;
              //   }, 0),
              // ]
              //   :
              //   [
              //     graphElitePass.reduce((total, value) => {
              //       return total + value.value;
              //     }, 0),
              //     graphOthers.reduce((total, value) => {
              //       return total + value.value;
              //     }, 0),
              //   ]
            }
            type="pie"
            //height={340}
            {...getProps()}
          />
        </Col>
      </Row>
      <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }}>
        {loading?(
          <Spinner animation="border" size="sm" />
        ):<>
          {!showNotData?<></>:<h6>Sem dados</h6>}
        </>}
      </div>
    </Card.Body>
  );
}